// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"screen-mirroring"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 19H2.00099L2 4H22L22 19L18.5 19M10.5 21L12 19.5L13.5 21L10.5 21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.5 11.5V8.92857C7.5 8.69188 7.72386 8.5 8 8.5H11C11.2761 8.5 11.5 8.69188 11.5 8.92857V11.5M7.5 11.5V14.5M7.5 11.5H11.5M11.5 11.5V14.5M15.5 8.5V14.5M15.5 8.5H14.5M15.5 8.5H16.5M15.5 14.5H16.5M15.5 14.5H14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ScreenMirroringIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'screen-mirroring',
    ref,
    icon: element,
  },
));

ScreenMirroringIcon.displayName = 'ScreenMirroringIcon';

export default ScreenMirroringIcon;
